export enum PathName {
    // 首页
    Home = 'home',
    // Dashboard
    Dashboard = 'dashboard',
    // 周报相关
    Report = 'report',
    // 创建周报
    WeeklyReport = 'weekly_report',
    // 周报列表
    ReportList = 'report_list',
    // 全量周报
    AdminReport = 'admin_report',
    // 全量Summary
    ReportSummary = 'report_summary',
    // 国内Summary
    ExSummary = 'ex_summary', 
    // 请假
    Attendance = 'attendance',
    // 新增请假
    AttRequest = 'att_request',
    // 请假列表
    AttList = 'att_list',
    // 请假明细
    AttStatus = 'att_status',
    // 请假转换
    AttTrans = 'att_transfer',
    // 请假日历
    AttCalendar = 'att_calendar',
    // 需求
    Requirement = 'requirement',
    // 新增需求
    ReqRequest = 'req_request',
    // 新增子需求
    SubReqRequest = 'sub_req_request',
    // 编辑需求
    ReqEdit = 'req_edit',
    // 需求列表
    ReqList = 'req_list',
    // 需求明细
    ReqDetail = 'req_detail',
    // 需求概要
    ReqSummary = 'req_summary',
    // 项目
    Project = 'project',
    // 项目查询
    ProjectList = 'project_list',
    // 创建项目
    ProjectInit = 'project_init',
    // 编辑项目
    ProjectEdit = 'project_edit',
    ProjectSummary = 'project_summary',
    ProjectKanban = 'project_kanban',
    // 任务看板
    Task = 'task',
    TaskKanban = 'task_kanban',
    TaskAdd = 'task_add',
    TaskEdit = 'task_edit',
    TaskList = 'task_list',
    TaskDetail = 'task_detail',
    TaskSummary = 'task_summary',
    // 测试工具
    TestTool = 'test_tool',
    // 辅助工具
    Flower = 'flower',

    // 修改密码
    SelfPassword = 'self_password',
    // 登录
    Login = 'login',
}
